import { PayloadAction } from '@reduxjs/toolkit';
import { DTOWordWithRelatedWords } from '@shared/dto/+word/word_with_related_words/dto_word_with_related_words';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { StateWords } from '../state_words';

export const local_words_similar_upsert = (items: DTOWordWithRelatedWords[]): PayloadAction<DTOWordWithRelatedWords[]> => ({
  type: ENUM__redux_action.WORDS_SIMILAR_UPSERT,
  payload: items,
});

export const init_local_words_similar_upsert = (state: StateWords, action: PayloadAction<DTOWordWithRelatedWords[]>) => {
  for (let item of action.payload) {
    state.words_with_related_words_map.set(item.word_english, item);
  }
};
